import React, { useState, useEffect } from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import BlackFridayImage from '@core/assets/images/blackfriday-main.svg?url';

import classes from './BlackFriday.module.scss';
import { COURSE_COUNT } from 'constants/site-stats.const';


const FlipCard = ({ value }) => {
    const [currentValue, setCurrentValue] = useState(value);
    const [flipping, setFlipping] = useState(false);

    useEffect(() => {
        if (value !== currentValue) {
            setFlipping(true);
            // setCurrentValue(value);           
            setTimeout(() => {
                setFlipping(false);
            }, 500); // Match animation duration
            setTimeout(() => {
                setCurrentValue(value);
            }, 250); // change value
        }
    }, [value, currentValue]);

    return (
        <div className={classes["flip-card"]}>
            <div className={classes.top}>
                <span>
                    {currentValue[0]}
                </span>
                <span>
                    {currentValue[1]}
                </span>
            </div>
            <div className={classes.bottom}>
                <span>
                    {currentValue[0]}
                </span>
                <span>
                    {currentValue[1]}
                </span>
            </div>
            {flipping && (
                <>
                    <div className={classes["top-flip"]}>
                        <span>
                            {currentValue[0]}
                        </span>
                        <span>
                            {currentValue[1]}
                        </span>
                    </div>
                    <div className={classes["bottom-flip"]}>
                        <span>
                            {value[0]}
                        </span>
                        <span>
                            {value[1]}
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

const TimerSegment = ({ title, tens, ones }) => (
    <div className={classes["container-segment"]}>
        <div className={classes.segment}>
            {/* <FlipCard value={tens} /> */}
            <FlipCard value={ones} />
        </div>
        <div className={classes["segment-title"]}>{title}</div>
    </div>
);

const Timer = ({ time }) => {
    const [timeLeft, setTimeLeft] = useState(Math.floor(time / 1000)); // 24 hours in seconds

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft((prev) => Math.max(prev - 1, 0));
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const days = Math.floor(timeLeft / (3600 * 24));
    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    return (
        <div className='d-flex gap-3'>
            <TimerSegment
                title="Days"
                tens={Math.floor(days / 10)}
                ones={('0' + days).slice(-2)}
            />
            <TimerSegment
                title="Hours"
                tens={Math.floor(hours / 24)}
                ones={('0' + hours % 24).slice(-2)}
            />
            <TimerSegment
                title="Minutes"
                tens={Math.floor(minutes)}
                ones={('0' + minutes).slice(-2)}
            />
            <TimerSegment
                title="Seconds"
                tens={Math.floor(seconds)}
                ones={('0' + seconds).slice(-2)}
            />
        </div>
    );
};

const BlackFriday = ({ data }) => {
    const year = new Date().getFullYear();

    const getDiffFromData = () => {
        if (!data) return 0;
        const target = data.valid_until ? new Date(data.valid_until) : new Date(data.valid_from);
        return Math.max(+target - Date.now(), 0);
    };

    const [difference, setDifference] = useState(getDiffFromData);

    useEffect(() => {
        setDifference(getDiffFromData());
    }, [data]);

    return (
        <div className={classes['wrapper']}>
            <div className='container'>
                <div className='d-flex flex-column align-items-center gap-4'>
                    <h3>
                        Pharmuni Black Friday 2025
                    </h3>
                    {data.valid_until ?
                        <>
                            <img src={BlackFridayImage} alt='Black Friday Image' />
                            <p>
                                Access all premium pharma courses and career paths with<strong> 50% off</strong> for one year. Offer ends December 1st!                                
                            </p>
                        </>
                        :
                        <>
                            <h1>
                                Get ready<br /> for our <span>Biggest Sale</span> of the year!
                            </h1>
                            <p>
                                Mark your calendar for <span className='text-decoration-underline'><strong>Nov 17th – Dec 1st</strong></span> and prepare to elevate your pharma career to an unbeatable price.
                            </p>

                        </>
                    }



                    <Timer time={difference} />

                    <div className='d-flex mt-4 gap-3 flex-column flex-sm-row'>
                        {data.valid_until ?
                            <LinkButton kind='primary-color' to={'/get-started'}>
                                Join for Free
                            </LinkButton>
                            :
                            <LinkButton kind='primary-color' to={'/register'}>
                                Sign Up to Get Notified
                            </LinkButton>
                        }
                        <LinkButton to={'/explore'}>
                            Explore {COURSE_COUNT}+ courses
                        </LinkButton>
                    </div>

                    {/* {data.valid_until} */}
                </div>
            </div>
        </div>
    );
};

export default BlackFriday;


